(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-2more-google"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('resenas-2more-{{ section.id }}');
  if (!section) return;

  var listContainer = section.querySelector('.resenas-2more-list');
  var apiKey = listContainer.dataset.googleApiKey;
  var placeId = listContainer.dataset.placeId;
  var maxReviews = parseInt(listContainer.dataset.maxReviews || '6', 10);

  if (!apiKey || !placeId) {
    listContainer.innerHTML =
      '<p style="color:#888;text-align:center;">Configura la API Key y el Place ID en la sección.</p>';
    return;
  }

  function loadMapsScript(callback) {
    if (window.google && window.google.maps && window.google.maps.places) {
      callback();
      return;
    }

    var existing = document.querySelector('script[data-resenas-2more="maps"]');
    if (existing) {
      existing.addEventListener('load', callback);
      return;
    }

    var script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(apiKey) +
      '&libraries=places&language=es';
    script.async = true;
    script.defer = true;
    script.dataset.resenas2more = 'maps';
    script.addEventListener('load', callback);
    document.head.appendChild(script);
  }

  function renderReviews() {
    var service = new google.maps.places.PlacesService(
      document.createElement('div')
    );

    service.getDetails(
      {
        placeId: placeId,
        fields: ['reviews']
      },
      function(place, status) {
        if (
          status !== google.maps.places.PlacesServiceStatus.OK ||
          !place ||
          !place.reviews
        ) {
          listContainer.innerHTML =
            '<p style="color:#888;text-align:center;">No se han podido cargar las reseñas.</p>';
          return;
        }

        var fiveStarReviews = place.reviews
          .filter(function(r) {
            return r.rating === 5;
          })
          .slice(0, maxReviews);

        if (!fiveStarReviews.length) {
          listContainer.innerHTML =
            '<p style="color:#888;text-align:center;">Todavía no hay reseñas de 5 estrellas.</p>';
          return;
        }

        listContainer.innerHTML = '';

        fiveStarReviews.forEach(function(review) {
          var card = document.createElement('article');
          card.className = 'resenas-2more-item';

          var name = review.author_name || '';
          var initial = name ? name.charAt(0).toUpperCase() : '★';
          var stars = '★★★★★';

          card.innerHTML =
            '<div class="resenas-2more-header">' +
              '<div class="resenas-2more-avatar">' + initial + '</div>' +
              '<div>' +
                '<div class="resenas-2more-name">' + name + '</div>' +
                '<div class="resenas-2more-stars">' + stars + '</div>' +
              '</div>' +
            '</div>' +
            '<p class="resenas-2more-text">' +
              (review.text || '') +
            '</p>';

          listContainer.appendChild(card);
        });
      }
    );
  }

  loadMapsScript(renderReviews);
})();

  } catch(e) { console.error(e); }
})();
})();
